import { useEffect } from 'react';

import { Box } from '@aicon-dev/caas-core';
import { Button } from 'antd-mobile';
import { LeftOutline, RightOutline } from 'antd-mobile-icons';
import dayjs from 'dayjs';
import { Navigate } from 'react-big-calendar';

import { CalendarHeader } from './Calendar.Header';
import { useSelectedDateStore } from './store';

export const CalendarToolbar = (props: any) => {
  const { setDate } = useSelectedDateStore();
  useEffect(() => {
    if (props.view === 'day') return;
    else {
      setDate(props.date);
    }
  }, [props.view, props.date]);
  return (
    <>
      <CalendarHeader {...props} />
      <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} p="8px 16px">
        <Button
          onClick={() => {
            props.onNavigate(Navigate.PREVIOUS);
          }}
        >
          <LeftOutline />
        </Button>

        <Box fontWeight={500}>
          {props.view === 'month' ? props.label : dayjs(props.label).format('ll')}
        </Box>

        <Button
          onClick={() => {
            props.onNavigate(Navigate.NEXT);
          }}
        >
          <RightOutline />
        </Button>
      </Box>
    </>
  );
};
